import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { fromApiEffectSwitchMap } from '@lib/store';
import {
  cancelCreateSkLkrlRequest,
  failCreateSkLkrl,
  setCreateSkLkrl,
  setCreateSkLkrlFromApi,
  updateCreateSkLkrl,
  updateCreateSkLkrlFromApi,
} from './create-sk-lkrl.actions';

/**
 * Service to handle async CreateSkLkrl actions
 */
@Injectable()
export class CreateSkLkrlEffect {
  /**
   * Set the state with the reply content, dispatch failCreateSkLkrl if it catches a failure
   */
  public setFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setCreateSkLkrlFromApi),
      fromApiEffectSwitchMap(
        (reply, action) => setCreateSkLkrl({ model: reply, requestId: action.requestId }),
        (error, action) => of(failCreateSkLkrl({ error, requestId: action.requestId })),
        cancelCreateSkLkrlRequest
      )
    )
  );

  /**
   * Update the state with the reply content, dispatch failCreateSkLkrl if it catches a failure
   */
  public updateFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateCreateSkLkrlFromApi),
      mergeMap((payload) =>
        from(payload.call).pipe(
          map((reply) => updateCreateSkLkrl({ model: reply, requestId: payload.requestId })),
          catchError((err) => of(failCreateSkLkrl({ error: err, requestId: payload.requestId })))
        )
      )
    )
  );

  constructor(protected actions$: Actions) {}
}
